<template>
  <div class="user">
    <div class="top">
      <!-- <img src="@assets/images/user_top_bg.png" class="top_bg" alt="" /> -->
      <!-- <div class="header acea-row row-between-wrapper">
        <div class="picTxt acea-row row-between-wrapper">
          <div class="pictrue"><img :src="userInfo.avatar" /></div>
          <div class="text">
            <div class="acea-row row-middle">
              <div class="name line1">{{ userInfo.nickname }}</div>
              <div class="">
                <div class="member acea-row row-middle" v-if="userInfo.vip">
                  <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
                </div>
              </div>
            </div>

            <router-link
              :to="'/user/data'"
              class="id"
              v-if="userInfo.account"
              style="margin-top: 0.2rem"
            >
              账号：{{ userInfo.account }}
            </router-link>
            <router-link
              :to="'/user/binding'"
              class="binding"
              v-if="!userInfo.phone"
            >
              <span>绑定手机号</span>
            </router-link>
          </div>
        </div>
        <span
          class="iconfont icon-shezhi"
          @click="$router.push({ path: '/user/data' })"
        ></span>
      </div> -->
      <div class="nav acea-row row-middle">
        <div class="item">
          <div class="num">{{ userInfo.total_num || 0 }}</div>
          <div>销售业绩</div>
        </div>
        <div class="item">
          <div class="num">{{ userInfo.total_num_xz || 0 }}</div>
          <div>本月新增业绩</div>
        </div>
        <!-- <div class="item">
          <div class="num">{{ userInfo.zg_box || 0 }}</div>
          <div>个人购买</div>
        </div> -->
      </div>
      <div class="nav acea-row row-middle">
        <!-- <div class="item" @click="goPagey2('/user/combination2')">
          <div class="num">{{ userInfo.total_num || 0 }}</div>
          <div>销售业绩</div>
        </div> -->
        <div class="item">
          <div class="num">{{ userInfo.zg_box || 0 }}</div>
          <div>个人购买</div>
        </div>
        <div class="item">
          <div class="num">{{ userInfo.xq_yj_xz || 0 }}</div>
          <div>小区新增业绩</div>
        </div>
      </div>
    </div>
    <img class="logo" src="@assets/images/logo3.png" alt="" />
  </div>
</template>

<script>
import { getUser, getMenuUser } from "@api/user";
import { isWeixin } from "@utils";

const NAME = "User";

export default {
  name: NAME,

  props: {},
  data: function() {
    return {
      userInfo: {},
      MyMenus: [],
      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: ""
      }
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    }
  },
  mounted: function() {
    this.User();
    this.MenuUser();
    this.isWeixin = isWeixin();
  },
  methods: {
    changeswitch: function(data) {
      this.switchActive = data;
    },
    User: function() {
      let that = this;
      getUser().then(res => {
        that.userInfo = res.data;
        that.orderStatusNum = res.data.orderStatusNum;
        let reg = /^(\d{3})\d*(\d{4})$/;
        that.userInfo.phone = that.userInfo.phone
          ? that.userInfo.phone.replace(reg, "$1****$2")
          : "";
        this.generalContent = {
          promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res
            .data.promoter_price || 0}元</span>即可开通推广权限`,
          title: "您未获得推广权限"
        };
      });
    },
    MenuUser: function() {
      let that = this;
      getMenuUser().then(res => {
        that.MyMenus = res.data.routine_my_menus;
      });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    goPagey2(url) {
      this.$router.push({ path: url });
    },
    goPages: function(index) {
      let url = this.MyMenus[index].wap_url;
      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    }
  }
};
</script>

<style lang="scss" scoped>
.user {
  padding-top: 0.2rem;
  height: 100vh;
  background-color: #fff;
  width: 100vw;
}
.footer-line-height {
  height: 1.5rem;
}
.logo {
  width: 3.2rem;
  height: auto;
  margin: 0 2.15rem;
}
.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 1px solid #ee5a52;
}

.pictrue {
  position: relative;
}
.switch-h5 {
  margin-left: 0.2rem;
}
.binding {
  padding: 0.05rem 0.2rem;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50px;
  font-size: 0.14rem;
  color: #ffffff;
}
.top {
  position: relative;
  // background: -webkit-gradient(
  //   linear,
  //   left top,
  //   right top,
  //   from(#0e98fd),
  //   to(#ff6533)
  // );
  // background: linear-gradient(0deg, #0e98fd, #ff6533);
  // background: -webkit-linear-gradient(0deg, #0e98fd, #ff6533);
  // background-image: url("../../assets/images/user_top_bg.png");
  background-size: 100% 100%;
  margin-bottom: 0.2rem;
  .top_bg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .header {
    z-index: 1;
  }
  .nav {
    position: relative;
    // height: 15vw;
    z-index: 1;
    padding: 0 0.3rem;
    flex-wrap: nowrap;
    justify-content: space-between;
    > a,
    > div {
      // width: 50%;
      text-align: center;
      > .num {
        color: #fff;
        font-size: 4.8vw;
        font-weight: 600;
      }
      span {
        border: 1px solid #fff;
        font-weight: 400;
        font-size: 3.47vw;
        padding: 0 1vw;
        border-radius: 1vw;
        line-height: 6vw;
      }
      > div {
        margin-top: 0.2rem;
        color: #fff;
        font-size: 2.94vw;
        font-weight: 400;
      }
    }
    .item {
      margin-bottom: 0.4rem;
      width: 47%;
      height: 2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-color: #0e98fd;
      border-radius: 10px;
    }
    > .middle {
      border-left: 1px solid #ffffff50;
      border-right: 1px solid #ffffff50;
    }
  }
}
.red_bag_pic {
  width: 100vw;
  margin-top: 3.5vw;
}
</style>
